<template>
  <div class="dashboard_report_wrapper">
    <base-header class="pb-6 bg-gradient-dark">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Statistics</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb></route-breadcrumb>
          </nav>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card title="Visits" type="gradient-info" sub-title="Info">
            <h5 class="card-title text-uppercase text-muted mb-0">Visits</h5>
            <div class="card-body pl-0 pb-0" v-if="loader && !loader.isActive">
              <div class="top_visitor">{{ visitor }}</div>
            </div>
          </stats-card>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-12 col-lg-4 order-lg-2">
          <period-selection
            title="Date Range"
            :date-filters="dateFilter"
            @change="handleChangeDateFilter"
          />
          <div
            v-if="topCountry && topCountry.country"
            class="card vistor_count p-3"
          >
            <h3 class="text-center">Top Country</h3>
            <p class="text-center top_visitor">{{ topCountry.country }}</p>
            <h3 class="text-center">Visits</h3>
            <span class="top_visitor">{{ topCountry.total }}</span>
          </div>
          <div v-if="visitor" class="card p-3">
            <h3 class="title">Visits by Country</h3>
            <PieChart
              :height="350"
              :chart-data="pieChart.chartData"
              :options="pieChart.extraOptions"
            >
            </PieChart>
          </div>
        </div>

        <div class="col-12 col-lg-8">
          <div class="card left_side shadow-bg">
            <h3 class="border-0 card-header">Clicks</h3>
            <BarChart
              :height="350"
              :chart-data="lineChart.chartData"
              :options="lineChart.extraOptions"
            >
            </BarChart>
          </div>
          <StatisticsTable :visitors="logs" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import BarChart from '@/components/Charts/BarChart'
import PieChart from '@/components/Charts/PieChart'
import PeriodSelection from '@/components/PeriodSelection'
import StatisticsTable from '@/components/StatisticsTable'

export default {
  name: 'AffiliateStatistics',
  components: {
    StatisticsTable,
    BarChart,
    PieChart,
    PeriodSelection
  },
  data() {
    return {
      loader: false,
      visitor: 0,
      topCountry: { total: 0, country: '' },
      fromDate: null,
      toDate: null,
      logs: [],
      dateFilter: [
        moment().subtract(30, 'days').startOf('day').toDate(),
        moment().startOf('day').toDate()
      ],
      lineChart: {
        chartData: {},
        extraOptions: {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        }
      },
      pieChart: {
        chartData: {}
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async handleChangeDateFilter(range) {
      if (
        range.length === 2 &&
        (moment(range[0]).unix() !== moment(this.dateFilter[0]).unix() ||
          moment(range[1]).unix() !== moment(this.dateFilter[1]).unix())
      ) {
        this.dateFilter = range
        await this.fetchData()
      }
    },
    async fetchData() {
      this.loader = this.$loading.show()
      const [fromDate, toDate] = this.dateFilter
      await this.axios
        .post(
          process.env.VUE_APP_ROOT_API +
            '/api/v1/affiliates/statistics/' +
            this.$route.params.id,
          {
            fromDate: fromDate.toISOString(),
            toDate: toDate.toISOString()
          }
        )
        .then(({ data }) => {
          this.lineChart.chartData = data.lineChartData
          this.pieChart.chartData = data.pieChartData
          this.visitor = data.affiliateLogs?.length || 0
          this.topCountry = data.topCountry || { total: 0, country: '' }
          this.logs = data.affiliateLogs
        })
        .catch(() =>
          this.$notify({ type: 'danger', message: 'Something went wrong!' })
        )
      this.loader.hide()
    },

    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    }
  }
}
</script>

<style scoped lang="scss">
.dashboard_report_wrapper {
  padding: 0;
  .vistor_count {
    //min-height: 200px;
  }
  .top_visitor {
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    color: #000;
  }
  .card-text {
    font-size: 24px;
    text-align: right;
    font-weight: bold;
  }
  .table_data {
    overflow: scroll;
  }
}
</style>
